export default __webpack_public_path__ + "static/media/RegisterWait2.bdc2cd66.JPG";